
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CampaignDetailsForAccountsTeamFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CampaignDetailsForAccountsTeam"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignStatusId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignCategoriesId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campaignCategoriesName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalTargetImpressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasStarted"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videosId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tmpVideo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hubspotDealId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"programmaticDealToken"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"adAccountName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nDmas"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nStates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nRetailers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nBanners"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nWholesalers"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nStores"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nZips"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"loopPercentage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoTitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dealId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numCreatives"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":430}};
    doc.loc.source = {"body":"fragment CampaignDetailsForAccountsTeamFields on CampaignDetailsForAccountsTeam {\n  id\n  name\n  startDate\n  endDate\n  campaignStatusId\n  campaignCategoriesId\n  campaignCategoriesName\n  totalTargetImpressions\n  hasStarted\n  videosId\n  tmpVideo\n  hubspotDealId\n  programmaticDealToken\n  adAccountName\n  nDmas\n  nStates\n  nRetailers\n  nBanners\n  nWholesalers\n  nStores\n  nZips\n  loopPercentage\n  videoTitle\n  dealId\n  numCreatives\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["CampaignDetailsForAccountsTeamFields"] = oneQuery(doc, "CampaignDetailsForAccountsTeamFields");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/campaign2/CampaignDetailsForAccountsTeamFieldsFragment.gql
// module id = b/IT
// module chunks = 87